/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import * as API from "../../http/api";
import * as FUNC from '../../functions/functions';
import { Typography, IconButton, Tooltip  } from "@mui/material";
import { AccountCircle, TrendingUp, InfoOutlined } from "@mui/icons-material";
import { useStyles } from "../../util/ComponentStyles"
import { format } from '../../util/DateUtil';
import SpaceTxTracking from '../modals/SpaceTxTracking'
import { openlightbox } from '../../util/Functions';
import { status } from '../../util/DataObject';

const AccountInformation = (props) => {
  const clasess = useStyles();
  const history = useHistory();
  const [content, setContent] = useState([]);
  const [upgrade, setUpgrade] = useState(false);
  const [catalogLevel, setCatalogLevel] = useState([]);
  const openpayPrefix = props.catalogs.openpayPrefix[0] ? props.catalogs.openpayPrefix[0].k : null;

  useEffect(() => {
    setContent([])
    if(props.hasOwnProperty('config') && props.config.hasOwnProperty('fields') && props.config.hasOwnProperty('actions')){
      dataWidget();
    }
  }, [props.data]);

  const dataWidget = async () => {
    props.data.map(async (item) => {
      let x = await FUNC.filter(item, props.config.fields.in);
      x = await FUNC.exclude(x, props.config.fields.ex);
      setContent(content => content.concat(x));
    })
  }
  const hasAction = (action) => {
    return props.config?.actions?.indexOf(action) > -1;
  };

  const getCatalog = async () => {
    props.changeLoader(true);
    let data = {
      catalog: {
        id: "customer.subproducts",
      },
    };
    
    let request = await API.service('getCatalog', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      setCatalogLevel(request.data.data.catalog)
      setUpgrade(true)
    }
    props.changeLoader(false);
  }

  const reload = async (uuid) => {
    let data = {
      data: {
          customer: {
              keyword: uuid
          },
          filters: {
              results_per_page: 50,
              page_number: 1,
              search_type: "uuid"
          }
      }
    }

    props.changeLoader(true);
    let requestCuenta = await API.service('dataPersonal', data, props.pos, props.changeAlert, props.changeLoader, history);
    if(requestCuenta.status == 200 && requestCuenta.data.data.response == 'OK'){
      await props.changeWidgets(JSON.parse(JSON.stringify(requestCuenta.data.data.widget)));
    }
    props.changeLoader(false);
  }

  const levelUpgrade = async (uuid, key) => {
    props.changeLoader(true);
    let data = {
      entity: {
        uuid: uuid,
        type: "space_account"
      },
      new_space_level : {
        profile : key.target.value,
        type : "1"
      }
    };

    let request = await API.service('spaceLevelUpgrade', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      await reload(content[0]["customer_uuid"])
      props.changeAlert(true, 'success', 'Nivel de cuenta actualizado con éxito');
    }
    setUpgrade(false)
    props.changeLoader(false);
  }

  const stpTools = async (uuid) => {
    props.changeLoader(true);
    let user = JSON.parse(localStorage.session);
    let data = {
      aql: `from stp_tools where cmd='consultaCuentas'; cuentas='${uuid}'`,
      agent: user["uuid"]
    }

    let request = await API.service( "alboQueryLanguaje", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status === 200 && request.data.data.response === "OK" && request.data.data.widget[0].content.response.datos) {
      let contentModal = {
        title: `Estatus de clabe interbancaria`,
        content: request.data.data.widget[0].content.response.datos
      }

      const as = <SpaceTxTracking 
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
        contentModal={contentModal}
        key='spaceTxTracking' 
      />
      openlightbox(as);
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al ejecutar consulta: " + detail);
    }
    props.changeLoader(false);
  };

  const displayInfo = (label, value) => {
    return <div key={label} className="dataBlockItem">
      <label className="neutral">{label}</label>                
      <div className="item_personal">{value}</div>
    </div>
  }

  const searchCards = (key) => {
    let find = {
      data: {
        customer: { keyword: key},
        filters: { results_per_page: 50, page_number: 1, search_type: 'email' }
      }
    }
    props.addWidget("tarjetas", find);
  }

  return (
    <div className="size-6 dataBlock">
    {props.data &&
      <div className="card">
        <Typography
          component="div"
          children={
            <div className={clasess.titleTable}>
              <h2 className={clasess.titleH2}>
                <AccountCircle className={clasess.iconTitle} />
                Información de cuenta
              </h2>
              <div className={`col-6 row ${clasess.headOptions}`}>
                {hasAction("levelUpgrade") && content.length > 0 && content.some((item) => item['subproduct_uuid']) &&
                  <Tooltip title="Nivel de Cuenta">
                    <IconButton onClick={getCatalog.bind(this)}>
                      <TrendingUp />
                    </IconButton>
                  </Tooltip>
                }
              </div>
            </div>
          }
        />        
        <div className={`dataBlock ${clasess.block}`}> 
          {content.map((value, a) => {
              return <div key={`block-${a}`}>
                {value['subproduct_uuid'] &&
                  <div key={`product-${a}`} className={`dataBlockItem ${clasess.pnl_type}`} style={{display: "flex"}}>
                    <label> 
                      <div className="tooltip rec_n4"> 
                        <span className="tooltiptext tooltip-bottom">Nivel de cuenta</span> 
                        {value.subproduct_uuid ? value.subproduct_uuid.replace('key-debit-', '') : ''}
                      </div>
                      {hasAction("stpStatus") && value['references'] && value['references']['clabe'] && (
                        <Tooltip title="Validar CLABE">
                          <IconButton onClick={stpTools.bind(this, value['references']['clabe'])}>
                            <InfoOutlined />
                          </IconButton>
                        </Tooltip>
                      )}
                    </label>
                    {upgrade && 
                      <select style={{width: "33%"}} value={""} onChange={levelUpgrade.bind(this, value["uuid"])}>
                        <option label={value['subproduct_uuid']} value={''} disabled hidden></option>
                        {catalogLevel.map((item, index) => {
                          if(!(item.v.includes("loan"))){
                            return <option key={`level-${index}`} value={item.k}>
                              {item.k}
                            </option>
                          }})
                        }
                      </select>
                    }
                  </div>          
                }

                <div key={`content-${a}`}>
                  {displayInfo("Número de cuenta", value["accountNumber"])}
                  {displayInfo("Tipo de cuenta", value["type"])}
                  {value["references"] && displayInfo("CLABE", value["references"]["clabe"])}
                  {value["references"] && value["references"]["clabe_spei"] && displayInfo("CLABE SPEI", value["references"]["clabe_spei"])}
                  {displayInfo("Estatus de la cuenta", status.map((c) =>{if(c.value === value.status){return c.label}}))}
                  {displayInfo("Fecha de apertura", format(value.cdate))}
                  {hasAction("reference") && value["references"]['providers'] && value["references"]['providers'].map((item) => {if(item.partner === "pespay" ){return displayInfo("Referencia Pespay", item.reference)}})}
                  {hasAction("reference") && value["references"]['providers'] && value["references"]['providers'].map((item) => {if(item.partner === "dapp" ){return displayInfo("Referencia Dapp", item.reference)}})}
                  {value["cards"]?.length > 0 && displayInfo("Productos", value.cards.map((card, i) => {
                    return  <div key={`card-${i}`}><a href="#" onClick={() => searchCards(value.email)}>Tarjeta {card.type === 'virtual' ? 'virtual' : 'física'}</a></div>
                  }))}
                  <hr />
                </div>
              </div>
          })}
        </div>
      </div>
    }
    </div>    
  );
}

export default AccountInformation;